import translations_de from './translations/de';
import translations_fr from './translations/fr';
import translations_es from './translations/es';

export default function translate(){
    // Make sure that the global object is defined. If not, define it.
    window.CKEDITOR_TRANSLATIONS = window.CKEDITOR_TRANSLATIONS || {};

    // Make sure that the dictionary for Polish translations exist.
    window.CKEDITOR_TRANSLATIONS[ 'de' ] = window.CKEDITOR_TRANSLATIONS[ 'de' ] || {};
    window.CKEDITOR_TRANSLATIONS[ 'de' ].dictionary =  window.CKEDITOR_TRANSLATIONS[ 'de' ].dictionary || {};
    window.CKEDITOR_TRANSLATIONS[ 'fr' ] = window.CKEDITOR_TRANSLATIONS[ 'fr' ] || {};
    window.CKEDITOR_TRANSLATIONS[ 'fr' ].dictionary =  window.CKEDITOR_TRANSLATIONS[ 'fr' ].dictionary || {};
    window.CKEDITOR_TRANSLATIONS[ 'es' ] = window.CKEDITOR_TRANSLATIONS[ 'es' ] || {};
    window.CKEDITOR_TRANSLATIONS[ 'es' ].dictionary =  window.CKEDITOR_TRANSLATIONS[ 'es' ].dictionary || {};
    
    // Extend the dictionary for Polish translations with your translations:
    Object.assign( window.CKEDITOR_TRANSLATIONS[ 'de' ].dictionary, translations_de );
    Object.assign( window.CKEDITOR_TRANSLATIONS[ 'es' ].dictionary, translations_es );
    Object.assign( window.CKEDITOR_TRANSLATIONS[ 'fr' ].dictionary, translations_fr );
}